import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import * as paths from "../../../constants/paths";
import {
  doFirstUpperRestLower,
  makeSalaryString,
  timeAgoShort,
} from "../../../helpers/helpers";
import {
  fetchJobs,
  searchJobsData,
  saveJobAction,
  applyJob,
  reportAnJob,
  reportAnJobPopup,
} from "../../../states/actions/fetchJobs";
import { useDispatch, useSelector } from "react-redux";
import JobApplyPopup from "../../common/JobApplyPopup";

export default function JobPosition({ job, companyData, jobs_page_content }) {
  // const [saved, setSaved] = useState(false);
  const tooltipRef = useRef(null);

  const authToken = useSelector((state) => state.fetchSignin.authToken);
  const [showSigninPopup, setShowSigninPopup] = useState(false);

  const showReportPopup = useSelector(
    (state) => state.fetchJobs.showReportPopup,
  );
  const isJobSaving = useSelector((state) => state.fetchJobs.isJobSaving);
  const isJobApplying = useSelector((state) => state.fetchJobs.isJobApplying);
  const isJobReporting = useSelector((state) => state.fetchJobs.isJobReporting);

  const [bookmarked, setBookmarked] = useState(job.saved);
  const [showApplyPopup, setShowApplyPopup] = useState(false);
  const [popupJob, setPopupJob] = useState(null);
  const [openTooltipJobId, setOpenTooltipJobId] = useState(null);
  const [applied, setApplied] = useState(job.applied);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setBookmarked(job.saved);
  }, [job.saved]);
  useEffect(() => {
    setApplied(job.applied);
  }, [job.applied]);

  const [open, setOpen] = useState(null);
  const ref = useRef();
  const isTooltipOpen = openTooltipJobId === job.id;
  // const toggle = (type) => setOpen(open === type ? null : type);
  const toggle = (type) => {
  setOpen((prev) => (prev === type ? null : type));
};


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (tooltipRef.current && !tooltipRef.current.contains(e.target)) {
        setOpen(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleCompanyClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenTooltipJobId(isTooltipOpen ? null : job.id);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target) &&
        !event.target.closest(".company-link") // allow clicking the <a>
      ) {
        setOpenTooltipJobId(null);
      }
    };

    if (isTooltipOpen) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isTooltipOpen]);

  const handleToggleReportPopup = () => {
    dispatch(reportAnJobPopup());
  };
  const dismissPopup = () => {
    setShowApplyPopup(false);
    setPopupJob(null);
  };

  // const handleJobApply = (id) => {
  //   dispatch(applyJob({ id }));
  // };
  const handleJobApply = (id) => {
    if (applied) return;
    dispatch(applyJob({ id }));
    setApplied(true);
    setPopupJob((prev) => (prev ? { ...prev, applied: 1 } : prev));
  };

  const handleSaveJob = (formData) => {
    if (bookmarked) return;
    dispatch(saveJobAction(formData));
    setBookmarked(true);
    setPopupJob((prev) => (prev ? { ...prev, saved: 1 } : prev));
  };
  // const handleTitleClick = (job) => {
  //   if (job.is_internal_or_external === "external") {
  //     if (isJobSaving) {
  //       return false;
  //     }
  //     setShowApplyPopup(true);
  //     setPopupJob(job);
  //     window.open(job.job_link, "_blank");
  //   } else {
  //     navigate(`/job-profile/${job.id}`);
  //   }
  // };

  const handleTitleClick = (job) => {
    if (job.is_internal_or_external === "external") {
      if (isJobSaving) return false;
      setShowApplyPopup(true);
      setPopupJob({
        ...job,
        saved: bookmarked ? 1 : 0,
        applied: applied ? 1 : 0,
      });
      window.open(job.job_link, "_blank");
    } else {
      navigate(`/job-profile/${job.id}`);
    }
  };

  // const handleSaveJob = (formData) => {
  //   if (job.saved) return;
  //   dispatch(saveJobAction(formData));
  //   setBookmarked((prev) => !prev);
  // };

  const handleReportAnJob = (formData) => {
    dispatch(reportAnJob(formData));
  };

  const handleShowSigninPopup = () => {
    setShowSigninPopup(!showSigninPopup);
  };
  return (
    <>
      <div className="job_block" id="jobs-section">
        <div className="text">
          <div className="heading">
            <Link
              to="#"
              onClick={() => handleTitleClick(job)}
              style={{ cursor: "pointer" }}
            >
              {job.title}
            </Link>
          </div>

          <ul className="mini_list">
            {/* <li>
                <img
                  src={paths.SITE_BASE_URL + "/images/icon_mini_briefcase.png"}
                  alt=""
                />
                Experience
              </li> */}
            <li>
              <img
                src={paths.SITE_BASE_URL + "/images/icon_mini_map_marker.png"}
                alt="Location"
              />
              <span>{job?.job_loaction}</span>
            </li>
            {/* <li>
              <img
                src={paths.SITE_BASE_URL + "/images/icon_mini_building.png"}
                alt="Company"
              />
              {companyData?.name}
              <span className="info"> */}
                {/* <strong></strong> */}
                {/* <div className="infoIn">
                  Based on Home Office data , {companyData?.name} sponsored{" "}
                  {job?.computed_cos_total ?? 0} people in 2025.
                </div>
              </span>
            </li> */}
            <li>
              <img
                src={paths.SITE_BASE_URL + "/images/pound1.png"}
                alt="Salary"
              />
              {makeSalaryString(
                job?.min_salary,
                job?.max_salary,
                doFirstUpperRestLower(job?.salary_interval),
              )}
            </li>
            {/* <li>
                <img
                  src={paths.SITE_BASE_URL + "/images/icon_mini_clock.png"}
                  alt=""
                />
                Full Time
              </li> */}
            {/* <li>
                <img
                  src={paths.SITE_BASE_URL + "/images/icon_mini_visa.png"}
                  alt=""
                />
                Visa Sponsored
              </li> */}
            {/* <li> */}
            {/* <img src="/images/icon_mini_wallet.png" alt="Salary" /> */}
            {/* <img
                className="sm_icon_pound"
                src={paths.SITE_BASE_URL + "/images/pound1.png"}
                alt="Salary"
              />
              <span>
                {makeSalaryString(
                  job?.min_salary,
                  job?.max_salary,
                  doFirstUpperRestLower(job?.salary_interval)
                )}
              </span>
            </li> */}
          </ul>

          {/* <ul className="mini_list">
            <li>
              <img
                src={paths.SITE_BASE_URL + "/images/icon_mini_briefcase.png"}
                alt=""
              />
              {job.experience}
            </li>
            <li>
              <img
                src={paths.SITE_BASE_URL + "/images/icon_mini_map_marker.png"}
                alt=""
              />
              {job.location}
            </li>
            <li>
              <img
                src={paths.SITE_BASE_URL + "/images/icon_mini_clock.png"}
                alt=""
              />
              {job.type}
            </li>
            <li>
              <img
                src={paths.SITE_BASE_URL + "/images/icon_mini_visa.png"}
                alt=""
              />
              {job.visa}
            </li>
          </ul> */}

          <p>{job?.description}</p>

          {/* <div className="tag_list">
            {job.skills.map((skill, index) => (
              <button key={index} type="button">
                {skill}
              </button>
            ))}
          </div> */}

          <div ref={ref} className="tooltip-wrapper-flex">
            {job.is_promoted === "1" && (
              <div className="tooltip-wrapper">
                <span className="featured_job_new">Promoted</span>
              </div>
            )}

            {job.likely_to_sponsor === "yes" && (
              <div className={`tooltip-wrapper ${open && "open"}`}ref={tooltipRef} >
                <Link
                  to=""
                  className="featured_job_new3"
                  onClick={(e) => (e.preventDefault(), toggle("likely"))}
                >
                  {jobs_page_content.likely_sponsor_label}
                </Link>
                {open === "likely" && (
                  <div className="globals">
                    <p className="globals_info">
                      {jobs_page_content.likely_sponsor_desc}
                    </p>
                  </div>
                )}
              </div>
            )}

            {job.definitely_sponsored === "yes" && (
              <div className={`tooltip-wrapper ${open && "open"}`} ref={tooltipRef}>
                <Link
                  to=""
                  className="featured_job_new2"
                  onClick={(e) => (e.preventDefault(), toggle("definitely"))}
                >
                  {jobs_page_content.definitely_sponsor_label}
                </Link>
                {open === "definitely" && (
                  <div className="globals">
                    <p className="globals_info">
                      {jobs_page_content.definitely_sponsor_desc}
                    </p>
                  </div>
                )}
              </div>
            )}

            {job.new_entrant === "yes" && (
              <div className={`tooltip-wrapper ${open && "open"}`} ref={tooltipRef}>
                <Link
                  to=""
                  className="featured_job_new4"
                  onClick={(e) => (e.preventDefault(), toggle("new"))}
                >
                  {jobs_page_content.new_entry_label}
                </Link>
                {open === "new" && (
                  <div className="globals">
                    <p className="globals_info">
                      {jobs_page_content.new_entry_desc}
                    </p>
                  </div>
                )}
              </div>
            )}

            {job.student_graduate === "yes" && (
              <div className={`tooltip-wrapper ${open && "open"}`} ref={tooltipRef}>
                <Link
                  to=""
                  className="featured_job_new5"
                  onClick={(e) => (e.preventDefault(), toggle("student"))}
                >
                  {jobs_page_content.student_label}
                </Link>
                {open === "student" && (
                  <div className="globals">
                    <p className="globals_info">
                      {jobs_page_content.student_desc}
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="book">
          <button
            type="button"
            className={`bookmark ${bookmarked ? "bookmarked" : ""}`}
            onClick={() => handleSaveJob({ id: job.id })}
            disabled={isJobSaving}
          >
            <img
              /* src={
                bookmarked
                  ? paths.SITE_BASE_URL + "/images/icon_mini_bookmark_fill.png"
                  : paths.SITE_BASE_URL + "/images/icon_mini_bookmark.png"
              } */
              src={
                  "/images/icon-bookmark.svg"
              }
              alt="bookmark"
            />
            {/* {bookmarked ? "Saved" : "Save"} */}
          </button>
          {/* <div className="salary">
              <img
                className="sm_icon_pound"
                src={paths.SITE_BASE_URL + "/images/british-pound-48.png"}
                alt="Salary"
              />
              {makeSalaryString(
                job?.min_salary,
                job?.max_salary,
                doFirstUpperRestLower(job?.salary_interval),
              )}
            </div> */}
          {/* <div className="posted">Posted {timeAgoShort(job?.created_date)}</div> */}
        </div>

        <div className="btm_blk">
          {/* <Link to={`/jobs/${job.id}`}>View Details</Link> */}

          {/* <div className="btn_blk"> */}
          {/* <button
              type="button"
              className="site_btn blank"
              onClick={() => handleSaveJob({ id: job.id })}
              disabled={isJobSaving}
            >
              <img
                src={
                  bookmarked
                    ? paths.SITE_BASE_URL +
                      "/images/icon_mini_bookmark_fill.png"
                    : paths.SITE_BASE_URL + "/images/icon_mini_bookmark.png"
                }
                alt="bookmark"
              />
              {bookmarked ? "Saved" : "Save"}
            </button> */}
          {/* <button
              type="button"
              className="site_btn"
              onClick={() => handleJobApply(job.id)}
            >
              {applied ? "Applied" : "Apply Now"}
            </button> */}
          {/* </div> */}
        </div>
      </div>
      {showApplyPopup && (
        <JobApplyPopup
          job={popupJob}
          dismissPopup={dismissPopup}
          handleJobApply={handleJobApply}
          isJobApplying={isJobApplying}
          saveJob={handleSaveJob}
          isJobSaving={isJobSaving}
          isJobReporting={isJobReporting}
          handleReportAnJob={handleReportAnJob}
          handleShowSigninPopup={handleShowSigninPopup}
          showSigninPopup={showSigninPopup}
          showReportPopup={showReportPopup}
          handleToggleReportPopup={handleToggleReportPopup}
        />
      )}
    </>
  );
}
